define(['jquery', 'jquery.transit', 'modernizr', 'container', 'preloader', 'underscore', 'jump', 'slider-carousel-infinite-enhanced'],
    function ($, transit, modernizr, container, preloader, _, jumpFactory, sliderCarouselInfiniteEnhancedFactory) {

        const videoPlayerVideoPlayAction = () => {
            return {
                type: 'VIDEO_PLAYER_VIDEO_PLAY',
                payload: {
                    videoPlaying: true
                }
            }
        };

        const videoPlayerVideoStopAction = () => {
            return {
                type: 'VIDEO_PLAYER_VIDEO_STOP',
                payload: {
                    videoPlaying: false
                }
            }
        };

        const videoPlayerAddPlayerAction = (player) => {
            return {
                type: 'VIDEO_PLAYER_PLAYER_ADD',
                payload: {
                    videoPlayer: player
                }
            }
        };

        const videoPlayerPlayReducer = (play = false, action) => {
            switch(action.type) {
                case 'VIDEO_PLAYER_VIDEO_PLAY':
                    return action.payload.videoPlaying;
                case 'VIDEO_PLAYER_VIDEO_STOP':
                    return action.payload.videoPlaying;
                default:
                    return play;
            }
        };

        const videoPlayerPlayerReducer = (player = null, action) => {
            if (action.type === 'VIDEO_PLAYER_PLAYER_ADD') {
                return action.payload.videoPlayer;
            } else {
                return player;
            }
        };

        return (function () {

            const name = 'module-video-player';

            const model = container.getBaseModel(name);
            const view = container.getBaseView(name);
            const pubSub = container.getPublishSubscribe();
            const carousel = sliderCarouselInfiniteEnhancedFactory.create();
            const jump = jumpFactory.create();
            /* model */

            model.publicVars = {};

            model.privateVars = {
                loadedItems: new Map()
            };

            model.methods = {
                getVideo: function (id) {
                    if(model.privateVars.loadedItems.has(id)) {
                        pubSub.publish('view/actionShowVideo', model.privateVars.loadedItems.get(id));
                    } else {
                        $.ajax({
                            url: model.publicVars.ajaxVideoPlayerEndpoint + '/' + id,
                            type: 'GET',
                            data: {}
                        }).done(function (data) {
                            model.privateVars.loadedItems.set(id, data);
                            pubSub.publish('view/actionShowVideo', data);
                        });
                    }
                },
            };

            /* view */

            view.publicVars = {};

            view.privateVars = {
                currentVideo: null,
                anim: 0,
                player: null,
                secondPlayerInit: false
            };

            view.startup = function () {

                view.privateVars.currentVideo = parseInt(view.publicVars.currentVideo);

                container.getReduxStore().reducerManager.add('videoPlayerVideoPlay', videoPlayerPlayReducer);
                container.getReduxStore().reducerManager.add('videoPlayerPlayer', videoPlayerPlayerReducer);
                container.getReduxStore().dispatch(videoPlayerVideoStopAction());
                container.getReduxStore().dispatch(videoPlayerAddPlayerAction(null));

                view.methods.setupBitmovin(view.publicVars.cssId.videoPlayerVideoId.substr(1), {});
            };

            view.bind = function () {

                $(view.publicVars.cssId.videoPlayerItemCls).click(function () {
                    const id = container.getData($(this)[0], 'id');

                    if (view.privateVars.currentVideo !== id && view.privateVars.anim === 0) {
                        container.msg(name + ' - video player item clicked ' + id);

                        view.privateVars.anim = 1;

                        view.privateVars.currentVideo = parseInt(id);

                        view.methods.handleVideoItemClick(id);
                    }
                });

                carousel.init(view.publicVars.carouselSetup);
                carousel.setElementDecorateCallback(view.methods.checkVideoActive);
            };

            view.methods = {
                setupBitmovin: (videoPlayerId, options) => {

                    const conf = {
                        key: view.publicVars.bitmovinKey,
                        analytics: false,
                        playback:{
                            autoplay: options.autoplay || false,
                            muted: false
                        },
                        logs: {
                            level: 'off'
                        },

                    };

                    let source = options.source || {
                        progressive: view.publicVars.initVideoSource
                    };

                    if(view.publicVars.initVideoPoster && !options.source) {
                        source.poster = view.publicVars.initVideoPoster;
                    }

                    view.privateVars.player = new bitmovin.player.Player(document.getElementById(videoPlayerId), conf);

                    container.getReduxStore().dispatch(videoPlayerAddPlayerAction(view.privateVars.player));

                    // Setup the player
                    view.privateVars.player.load(source).then(function() {

                    }, function () {

                    });

                    view.privateVars.player.on(bitmovin.player.PlayerEvent.SourceLoaded, function(e) {
                        if(options.sourceLoadedAction) {
                            view.methods.showVideoItem();
                        }
                    });

                    view.privateVars.player.on(bitmovin.player.PlayerEvent.Error, function(e) {
                        if(options.sourceLoadedAction) {
                            view.methods.showVideoItem();
                        }
                    });

                    view.privateVars.player.on(bitmovin.player.PlayerEvent.Play, function(e) {
                        container.getReduxStore().dispatch(videoPlayerVideoPlayAction());

                        jump.centerTo(view.publicVars.cssId.videoPlayerVideoId, () => {

                        });

                        const state = container.getReduxStore().getState();
                        if(state.trailerPlayer) {
                            state.trailerPlayer.pause();
                        }

                        if(state.spotifyIframe) {
                            state.spotifyIframe.src = state.spotifyIframe.src;
                        }
                    });

                    view.privateVars.player.on(bitmovin.player.PlayerEvent.Playing, function(e) {

                    });

                    view.privateVars.player.on(bitmovin.player.PlayerEvent.Paused, function(e) {
                        container.getReduxStore().dispatch(videoPlayerVideoStopAction());
                    });


                    view.privateVars.player.on(bitmovin.player.PlayerEvent.PlaybackFinished, function(e) {
                        container.getReduxStore().dispatch(videoPlayerVideoStopAction());
                    });
                },

                handleVideoItemClick: (id) => {
                    $(view.publicVars.cssId.videoPlayerItemCls).removeClass(view.publicVars.cssId.isActiveCls.substr(1));
                    $('#' + view.publicVars.cssId.videoPlayerItemCls.substr(1) + id).addClass(view.publicVars.cssId.isActiveCls.substr(1));

                    const oldHeight = $(view.publicVars.cssId.videoPlayerInnerId).outerHeight();
                    const headerHeight = $(view.publicVars.cssId.headerCls).outerHeight();
                    let submenuHeight = $(view.publicVars.cssId.headerSeriesSubmenuArrowWrapperCls).outerHeight() -
                        parseInt($(view.publicVars.cssId.headerSeriesSubmenuArrowWrapperCls).css('bottom')) - 30;

                    if($(view.publicVars.cssId.headerSeriesSubmenuCls).css('display') === 'none') {
                        submenuHeight = 0;
                    }

                    const newWindowHeight = $(window).height() - submenuHeight - headerHeight;

                    let newHeight = oldHeight;

                    if(newHeight > newWindowHeight) {
                        newHeight = newWindowHeight;
                    }

                    $(view.publicVars.cssId.videoPlayerInnerId).transit({opacity: 0}, 300, function () {
                        $(view.publicVars.cssId.videoPlayerInnerId).css({ height: newHeight + 'px', minHeight: '0px', visibility: 'hidden', overflow: 'hidden'});

                        $(view.publicVars.cssId.videoPlayerLoaderId).css({display: 'block', opacity: 0});
                        $(view.publicVars.cssId.videoPlayerLoaderId).transit({opacity: 1});

                        container.getReduxStore().dispatch(videoPlayerVideoStopAction());

                        jump.centerTo(view.publicVars.cssId.videoPlayerLoaderId, () => {
                            model.methods.getVideo(id);
                        }, {
                            modifier: - parseInt(headerHeight + submenuHeight)
                        });
                    });
                },

                checkVideoActive: (elem) => {
                    const id = container.getData(elem[0], 'id');

                    if (parseInt(id) === view.privateVars.currentVideo) {
                        $(view.publicVars.cssId.videoPlayerItemCls, elem).addClass(view.publicVars.cssId.isActiveCls.substr(1));
                    } else {
                        $(view.publicVars.cssId.videoPlayerItemCls, elem).removeClass(view.publicVars.cssId.isActiveCls.substr(1));
                    }

                    return elem;
                },

                actionShowVideo: (action, data) => {

                    preloader.preloadSingleImage(name, data.item_images['video_player_poster'][0], () => {
                        $(view.publicVars.cssId.videoPlayerDataTitleId).html(data.title);
                        $(view.publicVars.cssId.videoPlayerDataContentId).html(data.content);

                        container.trackInteraction('show video click', {
                            'subsection': 'series|video',
                            'contenttype': 'video',
                            'contenttitle': data.title.toLowerCase().replace(/"/g, "'")
                        });

                        if(data.content !== '') {
                            $(view.publicVars.cssId.videoPlayerDataContentId).css({ display: 'block'});
                        } else {
                            $(view.publicVars.cssId.videoPlayerDataContentId).css({ display: 'none'});
                        }

                        if(view.privateVars.secondPlayerInit) {
                            view.privateVars.player.load({
                                progressive: data.item_images['video_player_video'][0],
                                poster: data.item_images['video_player_poster'][0]
                            });
                        } else {
                            view.privateVars.secondPlayerInit = true;

                            view.privateVars.player.unload();
                            view.privateVars.player.destroy();

                            $(view.publicVars.cssId.videoPlayerVideoId).remove();

                            view.methods.setupBitmovin(view.publicVars.cssId.videoPlayerVideoSecondId.substr(1), {
                                autoplay: true,
                                sourceLoadedAction: true,
                                source: {
                                    progressive: data.item_images['video_player_video'][0],
                                    poster: data.item_images['video_player_poster'][0]
                                }
                            });
                        }
                    });

                },

                showVideoItem: () => {

                    const oldHeight = $(view.publicVars.cssId.videoPlayerInnerId).outerHeight();

                    $(view.publicVars.cssId.videoPlayerInnerId).removeAttr('style');

                    const newHeight = $(view.publicVars.cssId.videoPlayerInnerId).outerHeight();

                    $(view.publicVars.cssId.videoPlayerInnerId).css({ height: oldHeight + 'px', opacity: 0});

                    $(view.publicVars.cssId.videoPlayerLoaderId).removeAttr('style');

                    $(view.publicVars.cssId.videoPlayerInnerId).transit({ height: newHeight + 'px'}, 300, () => {

                        $(view.publicVars.cssId.videoPlayerInnerId).css({ visibility: 'visible'});

                        $(view.publicVars.cssId.videoPlayerInnerId).transit({opacity: 1}, 300, function () {
                            $(view.publicVars.cssId.videoPlayerInnerId).removeAttr('style');
                            view.privateVars.anim = 0;
                        });
                    });

                }
            };

            /* custom events */
            pubSub.subscribe('view/actionShowVideo', view.methods.actionShowVideo);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    view.init(options);
                }
            };


        })();

    });
